import React, { useMemo } from "react";
import "../css/DoctorAppointmentServicesCard.css"; // Create or reuse this CSS


const DoctorAppointmentServicesCard = ({ data = [] }) => {
  const doctorData = useMemo(
    () => data.find((item) => item.service === "Doctor Appointment"),
    [data]
  );

  const totalAppointments = doctorData?.total_appointments || 0;
  const totalRevenue = doctorData?.total_revenue || 0;
  const ongoing = doctorData?.ongoing_appointments || 0;
  const pending = doctorData?.pending_appointments || 0;
  const completed = doctorData?.completed_appointments || 0;
  const topVet = doctorData?.top_veterinarian || "—";

  return (
    <div className="doctor-service-card">
      <div className="doctor-service-title">Doctor Appointment</div>
      <div className="doctor-service-content">
        <div className="doctor-service-row">
          <span className="doctor-service-label">Total Appointments</span>
          <span className="doctor-service-colon">:</span>
          <span className="doctor-service-value">{totalAppointments}</span>
        </div>
        <div className="doctor-service-row">
          <span className="doctor-service-label">Total Revenue</span>
          <span className="doctor-service-colon">:</span>
          <span className="doctor-service-value">₹{totalRevenue.toLocaleString()}</span>
        </div>
        <div className="doctor-service-row">
          <span className="doctor-service-label">Ongoing</span>
          <span className="doctor-service-colon">:</span>
          <span className="doctor-service-value">{ongoing}</span>
        </div>
        <div className="doctor-service-row">
          <span className="doctor-service-label">Pending</span>
          <span className="doctor-service-colon">:</span>
          <span className="doctor-service-value">{pending}</span>
        </div>
        <div className="doctor-service-row">
          <span className="doctor-service-label">Completed</span>
          <span className="doctor-service-colon">:</span>
          <span className="doctor-service-value">{completed}</span>
        </div>
        <div className="doctor-service-row">
          <span className="doctor-service-label">Top Veterinarian</span>
          <span className="doctor-service-colon">:</span>
          <span className="doctor-service-value">{topVet}</span>
        </div>
      </div>
    </div>
  );
};

export default DoctorAppointmentServicesCard;
